/// <reference types="google.maps" />

import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
} from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { GooglePlacesAddressService } from '@core/services';
import { AddressPrefix } from '@shared/enums';

@Directive({
  selector: '[appAddressAutocomplete]',
})
export class AddressAutocompleteDirective implements AfterViewInit, OnDestroy {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef as any);
  private formGroupDir = inject(FormGroupDirective);
  private platformId = inject(PLATFORM_ID);
  private placesAddress = inject(GooglePlacesAddressService);

  @Input('appAddressAutocomplete') prefix!: AddressPrefix;
  @Input() country: string | string[] = 'us';

  private autocomplete?: google.maps.places.Autocomplete;
  private placeChangedListener?: google.maps.MapsEventListener;

  async ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.autocomplete = await this.placesAddress.createAddressAutocomplete(
      this.el.nativeElement,
      this.country,
    );
    if (!this.autocomplete) return;

    this.placeChangedListener = this.autocomplete.addListener(
      'place_changed',
      () => {
        const autocomplete = this.autocomplete;

        if (!autocomplete) {
          return;
        }

        const place = autocomplete.getPlace();
        if (!place?.address_components) return;
        this.placesAddress.patchAddressForm(
          this.formGroupDir.form,
          this.prefix,
          this.placesAddress.parseAddressComponents(place.address_components),
        );
      },
    );
  }

  ngOnDestroy(): void {
    this.placeChangedListener?.remove();
    if (this.autocomplete) {
      google.maps.event.clearInstanceListeners(this.autocomplete);
      this.autocomplete = undefined;
    }
  }
}
